export enum ZPrinterMeanType {
  Good = 'good',
  Service = 'service',
}
